(() => {
 'use strict';
 const root = document.body.dataset.root || '/';
 const drawer = document.getElementById('cart-drawer');
 let returnFocus, pending = false;
 async function request(url, options) {
   const response = await fetch(url, options);
   let data;
   try { data = await response.json(); }
   catch { throw new Error('The cart service could not be reached. Please try again or open the cart page.'); }
   if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
   return data;
 }
 function close() { drawer?.close(); document.body.style.overflow = ''; returnFocus?.focus(); }
 async function refresh() {
   const response = await fetch(root + '?section_id=cart-fragment', {headers:{'X-Requested-With':'XMLHttpRequest'}});
   if (!response.ok) throw new Error('Cart could not be displayed. Open the cart page to review your items.');
   const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
   const fragment = doc.querySelector('[data-cart-fragment]');
   if (!fragment) throw new Error('Cart could not be displayed. Open the cart page to review your items.');
   drawer.querySelector('[data-cart-content]').replaceChildren(fragment);
   document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = fragment.dataset.count);
 }
 async function open() {
   if (!drawer?.showModal) { location.href = root + 'cart'; return; }
   if (!drawer.open) { returnFocus = document.activeElement; drawer.showModal(); document.body.style.overflow = 'hidden'; }
   drawer.querySelector('[data-cart-error]').textContent = '';
   try { await refresh(); } catch (e) { drawer.querySelector('[data-cart-error]').textContent = e.message; }
 }
 document.addEventListener('click', async e => {
   const trigger = e.target.closest('[data-cart-open]');
   if (trigger) { e.preventDefault(); open(); }
   if (e.target.closest('[data-cart-close]')) close();
   const remove = e.target.closest('[data-cart-remove]');
   if (remove && !pending) {
     pending = true; remove.disabled = true;
     try { await request(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})}); await refresh(); drawer.querySelector('[data-cart-close]')?.focus(); }
     catch(error) { drawer.querySelector('[data-cart-error]').textContent = error.message; }
     finally { pending = false; if(remove.isConnected) remove.disabled = false; }
   }
 });
 drawer?.addEventListener('cancel', e=>{e.preventDefault();close();});
 drawer?.addEventListener('click', e=>{if(e.target===drawer){const r=drawer.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
 // Native form submission remains the no-JS fallback; FormData includes quantity, plans and properties.
 document.addEventListener('submit', async e => {
   const form=e.target.closest('[data-product-form]');
   if(!form || !window.fetch) return;
   e.preventDefault(); if(form.dataset.busy==='true'||form.dataset.variantPending==='true') return;
   const button=form.querySelector('[name=add]'), status=form.querySelector('[data-product-status]');
   form.dataset.busy='true';button.disabled=true;status.textContent='Adding to your bag…';
   try { await request(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});status.textContent='Added to your bag.';await open(); }
   catch(error){status.textContent=error.message;}
   finally{form.dataset.busy='false';button.disabled=form.querySelector('[name=id] option:checked')?.dataset.available==='false';}
 });
 document.addEventListener('keydown', e=>{if(e.key==='Escape') document.querySelectorAll('.x-header details[open]').forEach(el=>{el.open=false;el.querySelector('summary')?.focus();});});
 const accent=document.querySelector('.x-cursor');
 if(accent && document.documentElement.dataset.cursor==='true' && document.documentElement.dataset.motion!=='false' && document.documentElement.dataset.lowPerformance!=='true' && matchMedia('(pointer:fine) and (prefers-reduced-motion:no-preference)').matches){
   document.addEventListener('pointermove',e=>{accent.hidden=false;accent.style.transform='translate('+e.clientX+'px,'+e.clientY+'px)';},{passive:true});
   document.addEventListener('pointerleave',()=>accent.hidden=true);
 }
 window.RLTH_CART={open,close,fetch:refresh};
 // Theme Editor may insert a new section whose custom element has not been loaded yet.
 const sectionLoads = new Set();
 document.addEventListener('shopify:section:load', event => {
   event.target.querySelectorAll('script[data-rlth-component][src]').forEach(source => {
     if(customElements.get(source.dataset.rlthComponent) || sectionLoads.has(source.src)) return;
     sectionLoads.add(source.src);
     const script=document.createElement('script');script.src=source.src;script.defer=true;
     script.addEventListener('error',()=>sectionLoads.delete(source.src),{once:true});
     document.head.append(script);
   });
 });
})();
